import React from 'react'
import Link from 'next/link'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import localization from '../localization'

import IconMedication from 'assets/media/icons/eh-icon-medications.svg'
import IconTest from 'assets/media/icons/eh-icon-test-results.svg'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import withLocalization from '@web/helpers/localizationUtils'

const BaseInfoCard = props => {
  const {
    style,
    title,
    linkTo,
    children,
    t
  } = props
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, style)

  return (
    <div style={styles.container}>
      <div style={styles.topContainer}>
        <span style={styles.icon}>
          {title === 'medications' && <IconMedication />}
          {title === 'testResults' && <IconTest />}
        </span>
        <div style={styles.title}>{t(title)}</div>
      </div>
      <div style={styles.middleContainer}>
        {children}
      </div>
      <div style={styles.bottomContainer}>
        <Link href={linkTo} style={styles.link}>
          {t('viewAll')}
        </Link>
      </div>
    </div>
  )
}

export default withLocalization(BaseInfoCard, localization)
